export enum EZpusob {
    MAIL = 'MAIL',
    PHYS = 'PHYS',
    PHNV = 'PHNV',
    PRXY = 'PRXY',
    VIRT = 'VIRT',
    EVOT = 'EVOT'
}
